'use strict';

module Patersons {

    export interface ChangeEmailCtrlScope extends ng.IScope {
        changeEmailDetails: ChangeEmailDetails;
        changeEmailForm: {form:ng.IFormController};
        errorHandler: any;
        events: Patersons.ChangeEmailCtrl;
        isBusy: boolean;
        emailChanged: boolean;
        profile: UserProfile;
        profileAddressDetails: ProfileAddress;
    }

    export class ChangeEmailCtrl extends IdentityBaseCtrl {

        scope: Patersons.ChangeEmailCtrlScope;
        location: ng.ILocationService;
        window: ng.IWindowService;
        state: angular.ui.IStateService;
        stateParams: angular.ui.IStateProvider;
        http: ng.IHttpService;
        identityService: Patersons.IdentityService;
        tokenService: Patersons.TokenService;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'identityService', 'navigationService', 'tokenService', 'sessionService'];

      constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, identityService, navigationService, tokenService, sessionService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.identityService = identityService;
            this.tokenService = tokenService;
            this.scope.profile = this.tokenService.tokenManager.profile;
            if (!this.scope.profile){
              window.localStorage.setItem('$psl.redirect_uri', window.location.href);
              this.tokenService.tokenManager.redirectForToken();
            }
            this.scope.events = this;

            this.scope.isBusy = false;
            this.scope.emailChanged = false;

            this.scope.profileAddressDetails = new ProfileAddress;
            this.scope.changeEmailForm = {form: null};
            this.scope.changeEmailDetails = new ChangeEmailDetails;
            this.scope.changeEmailDetails.newEmail = this.scope.profile.email;
            this.load();
        }

        load(){
          var promise = this.identityService.getUserAddressDetails();
          promise.then((result: any) => {
            this.scope.profileAddressDetails.addressLine1 = result["addressLine1"];
            this.scope.profileAddressDetails.addressLine2 = result["addressLine2"];
            this.scope.profileAddressDetails.addressLine3 = result["addressLine3"];
            this.scope.profileAddressDetails.addressLine4 = result["addressLine4"];
            this.scope.profileAddressDetails.postcode = result["postcode"];
            this.scope.profileAddressDetails.country = result["country"];
            console.log(this.scope.profileAddressDetails);
          });
        }

        changeEmail() {
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.changeEmailForm.form.$invalid) {
                return;
            }

            this.scope.isBusy = true;

            this.identityService.changeEmail(this.scope.changeEmailDetails)
                .then((result) => {
                  this.scope.emailChanged = true;
                  setTimeout(() =>{
                    this.tokenService.tokenManager.redirectForToken();
                  }, 2000);
                },
                (reason) => {
                    this.scope.errorHandler = reason.data;
                })
                .finally(() => {
                    this.scope.isBusy = false;
                });
        }


    }
}
